import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color, shadow, border } from '@metro-ui/tokens/js';
import { rgba } from '../../utils/rgba';
import { OutsideClick } from '../../utils/OutsideClick';
import { Layout } from '../../Layout';
import { SidebarContext } from './SidebarContext';
import { slideInAnimation, slideOutAnimation } from './SidebarAnimations';
export var SidebarDrawer = styled(/** @class */ (function (_super) {
    __extends(SidebarDrawer, _super);
    function SidebarDrawer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEsc = function (e) {
            if ((e.key === 'Escape' || e.key === 'Esc') && _this.props.onDismiss) {
                _this.props.onDismiss(e);
            }
        };
        return _this;
    }
    SidebarDrawer.prototype.componentDidMount = function () {
        window.addEventListener('keyup', this.handleEsc);
    };
    SidebarDrawer.prototype.componentWillUnmount = function () {
        window.removeEventListener('keyup', this.handleEsc);
    };
    SidebarDrawer.prototype.render = function () {
        var _a = this.props, onDismiss = _a.onDismiss, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["onDismiss", "className", "children"]);
        return (React.createElement(OutsideClick, { onOutsideClick: onDismiss }, function (_a) {
            var outsideClickRef = _a.outsideClickRef;
            return (React.createElement(SidebarContext.Consumer, null, function (_a) {
                var isExpanded = _a.isExpanded;
                return (React.createElement(Layout, __assign({}, htmlAttributes, { direction: "column", className: className, ref: outsideClickRef, "data-is-expanded": isExpanded }), children));
            }));
        }));
    };
    return SidebarDrawer;
}(React.Component)))(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 5rem;\n    width: calc(21.75rem - ", ");\n    z-index: -1;\n    background-color: ", ";\n    color: ", ";\n    box-shadow: ", " ", ";\n    border-right: ", " solid ", ";\n    transition: left 0.2s ease-in-out;\n\n    &[data-is-expanded='true'] {\n      left: 21.75rem;\n    }\n\n    ", "\n    ", "\n  "], ["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 5rem;\n    width: calc(21.75rem - ", ");\n    z-index: -1;\n    background-color: ", ";\n    color: ", ";\n    box-shadow: ", " ", ";\n    border-right: ", " solid ", ";\n    transition: left 0.2s ease-in-out;\n\n    &[data-is-expanded='true'] {\n      left: 21.75rem;\n    }\n\n    ", "\n    ", "\n  "])), border.width.thin, color.contrast.white, color.neutral, shadow.medium.default, rgba(shadow.color, shadow.alpha), border.width.thin, color.palette.grey.tint[90], slideInAnimation, slideOutAnimation); });
SidebarDrawer.propTypes = {
    onDismiss: PropTypes.func.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=SidebarDrawer.js.map